import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sliceProgress]',
})
export class SliceProgressDirective {
  @Input() set sliceProgress(progress: number | undefined) {
    this._sliceProgress = progress || 0;
  }

  private _sliceProgress = 0;

  @HostBinding('class.accent-bg') get isCompleted() {
    return this._sliceProgress === 100;
  }

  constructor() {}
}
